import XiaomiLogo from "../../assets/img/grupos/grupos xiaomi.png";
import SamsungLogo from "../../assets/img/grupos/grupos samsung.png";
import MotorolaLogo from "../../assets/img/grupos/grupos motorola.png";
import AppleLogo from "../../assets/img/grupos/grupos apple.png";
import GeralLogo from "../../assets/img/grupos/grupos gerais jersu indica.png";
import HiperfocoLogo from "../../assets/img/grupos/hiperfoco em carros.png";
import PerfumesLogo from "../../assets/img/grupos/Grupos perfumes.png";

const configs = {
  ofertas: {
    tipo: "ofertas",
    titulo: "GERAIS",
    subtitulo: "Produtos pela <b>METADE DO PREÇO</b> ⚡",
    imagem: GeralLogo,
    selo: "JERSU INDICA OFERTAS",
    wppIcon: true,
    pixelId: "480319890575162",
  },
  celular: {
    tipo: "celular",
    titulo: "CELULAR",
    subtitulo: "As melhores promoções de <b>celulares</b> 📱",
    cor: "#0e7a4a",
    selo: "JERSU INDICA CELULAR",
    wppIcon: true,
    pixelId: null,
  },
  xiaomi: {
    tipo: "xiaomi",
    titulo: "XIAOMI",
    subtitulo: "Promoções exclusivas de <b>Xiaomi</b> ⚡",
    imagem: XiaomiLogo,
    selo: "JERSU INDICA XIAOMI",
    wppIcon: true,
    pixelId: "28109338928661651",
  },
  samsung: {
    tipo: "samsung",
    titulo: "SAMSUNG",
    subtitulo: "Promoções exclusivas de <b>Samsung</b> 📱",
    imagem: SamsungLogo,
    selo: "JERSU INDICA SAMSUNG",
    wppIcon: true,
    pixelId: "728431042277993",
  },
  motorola: {
    tipo: "motorola",
    titulo: "MOTOROLA",
    subtitulo: "Promoções exclusivas de <b>Motorola</b> 📱",
    imagem: MotorolaLogo,
    selo: "JERSU INDICA MOTOROLA",
    wppIcon: true,
    pixelId: "825742255333005",
  },
  apple: {
    tipo: "apple",
    titulo: "APPLE",
    subtitulo: "Promoções exclusivas de <b>Apple</b> 🍎",
    imagem: AppleLogo,
    selo: "JERSU INDICA APPLE",
    wppIcon: true,
    pixelId: "1122593015018136",
  },
  hiperfoco: {
    tipo: "hiperfoco",
    titulo: "HIPERFOCO",
    subtitulo: "Ofertas com <b>foco total</b> pra você 🎯",
    imagem: HiperfocoLogo,
    cor: "#e91e63",
    selo: "JERSU - HIPERFOCO EM CARROS",
    wppIcon: true,
    pixelId: "1743010964496802",
  },
  perfumes: {
    tipo: "perfumes",
    titulo: "PERFUMES",
    subtitulo: "Fragrâncias com <b>preço de verdade</b> ✨",
    imagem: PerfumesLogo,
    cor: "#c2185b",
    selo: "JERSU INDICA PERFUMES",
    wppIcon: true,
    pixelId: "1498712044615630",
  },
};

export default configs;
